import { css } from "@compiled/react";

import { Adg4Button } from "@/components/adg4/button/src";

import { useSiteActivationContext } from "../../hooks/site-activation-context";

export const SubmitButton = ({ submitMessage }: { submitMessage: string }) => {
    const { isSubmitting, hasSubmitted } = useSiteActivationContext();

    return (
        <div css={buttonStyles}>
            <Adg4Button
                isDisabled={isSubmitting || hasSubmitted}
                isLoading={isSubmitting || hasSubmitted}
                type="submit"
                dataEventProps={{
                    "data-product-key": "jira",
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": "siteName",
                    "data-label": "continue-or-agree",
                    "data-label-english": submitMessage,
                    "data-track-event":
                        "jira-site-name.site-name-form.atlas-66195.site-name"
                }}
            >
                {submitMessage}
            </Adg4Button>
        </div>
    );
};

const buttonStyles = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ["button"]: {
        width: "100%"
    }
});
